<template>
  <div class="invite-content">
    <img class="img_logo" src="../../assets/imgs/logo.png" alt="" />
    <div class="tips">{{ i18n.invite_tips }}</div>

    <!-- 二维码 -->
    <div class="qrcode-wrapper" v-if="inviterCode">
      <vue-qr
        :text="qrCodeUrl"
        :size="200"
        :margin="10"
        :correct-level="2"
      ></vue-qr>
    </div>

    <!-- 邀请码 -->
    <div class="tips">{{ i18n.invite_code }}</div>
    <div class="inviter-code">{{ inviterCode }}</div>

    <!-- 下载按钮 -->
    <div class="downloadbtn btn" @click="onDownload">
      <span>{{ i18n.download }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueQr from "vue-qr";

export default {
  components: {
    vueQr
  },
  computed: {
    ...mapState(["system"]),
    i18n() {
      return this.$t("result");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    qrCodeUrl() {
      return `https://m.chargee.bg/#/?inviterCode=${this.inviterCode}`;
    }
  },
  data() {
    return {
      inviterCode: ''
    }
  },
  methods: {
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY;
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE;
      }
      if (dowmloadUrl) {
        location.replace(dowmloadUrl);
      } else {
        this.$toast(this.i18nMsg.appoffline);
      }
    }
  },
  created() {
    this.inviterCode = this.$route.query.inviterCode
  }
};
</script>

<style lang="less">
.invite-content {
  padding-top: 80px;
  background: #fff;
  min-height: 100vh;

  .img_logo {
    max-width: 44%;
    display: block;
    margin: 0 auto 40px;
  }

  .tips {
    line-height: 1.8;
    font-size: 28px;
    color: #41200f;
    text-align: center;
    margin: 0 60px 40px;
  }

  .qrcode-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
  }

  .inviter-code {
    text-align: center;
    font-size: 42px;
    font-weight: bold;
    color: #333;
    margin: 20px 0;
  }

  .downloadbtn {
    width: 80%;
    margin: 40px auto 0;
    font-family: "DIN Condensed Bold";
    font-size: 46px;
    font-weight: bold;
    padding: 8px 0;
    border-radius: 20px;

    span {
      display: block;
    }
  }
}
</style>
